<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Certification Information"/>

        <container-list-item padded no-border>
            <b-field label="Title" label-position="inside">
                <b-input v-model="certification.title"></b-input>
            </b-field>
        </container-list-item>

        <template v-if="certification.id">
            <subheader-list-item title="Course Categories" icon="fa-folder-tree"/>

            <card-list-item v-for="cat in sortedCategories" :key="cat.id">
                <template #icon><i class="fa-fw fas fa-folder"></i></template>
                <template #content>
                    {{ cat.title }}
                </template>
                <template #details>
                    <div class="mt-3">
                        <toolbar class="toolbar">
                            <button class="icon-only" @click.stop="deleteCategory(cat)"><i class="far fa-trash"></i></button>
                        </toolbar>
                    </div>
                </template>
            </card-list-item>

            <card-list-item class="pb-5" no-hover>
                <template #icon><i class="fa-fw fas fa-plus"></i></template>
                <template #content>
                    <div class="columns">
                        <div class="column is-10">
                            <b-input
                                v-model="newCategoryTitle"
                                placeholder="New category title"
                                @keyup.native.enter="addCategory"
                            ></b-input>
                        </div>
                        <div class="column has-text-right">
                            <p class="control">
                                <button class="button is-primary" :disabled="!newCategoryTitle || !newCategoryTitle.trim()" @click="addCategory"><i class="far fa-fw fa-plus"></i></button>
                            </p>
                        </div>
                    </div>
                </template>
            </card-list-item>
        </template>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import {client as http} from "@/http_client";
    import Toolbar from "@/TIER/components/Toolbar";

    export default {
        name: 'CertificationForm',
        props: {
            certification: {
                type: Object,
                required: true
            },
        },
        components: {CardListItem, ContainerListItem, SubheaderListItem, CardList, Toolbar},
        data: function() {
            return {
                categories: [],
                newCategoryTitle: ''
            };
        },
        computed: {
            sortedCategories() {
                return [...this.categories].sort((a, b) => a.title.localeCompare(b.title));
            }
        },
        watch: {
            'certification.id': {
                immediate: true,
                handler(id) {
                    if (id) {
                        this.loadCategories();
                    }
                }
            }
        },
        methods: {
            loadCategories() {
                http.get('course-categories/', {
                    params: { certificationId: this.certification.id }
                }).then(response => {
                    this.categories = response.data;
                }).catch(err => {
                    console.log(err);
                });
            },
            addCategory() {
                if (!this.newCategoryTitle || !this.newCategoryTitle.trim()) return;
                http.post('course-categories/', {
                    certification_id: this.certification.id,
                    title: this.newCategoryTitle.trim()
                }, {force: true}).then(response => {
                    this.categories.push(response.data);
                    this.newCategoryTitle = '';
                }).catch(err => {
                    console.log(err);
                });
            },
            deleteCategory(cat) {
                http.delete('course-categories/' + cat.id, {force: true}).then(response => {
                    this.categories.splice(this.categories.indexOf(cat), 1);
                }).catch(err => {
                    console.log(err);
                });
            }
        }
    };
</script>
